import Select from "../../../../../src/components/select/Select";
import { Playground, Props } from 'docz';
import * as React from 'react';
export default {
  Select,
  Playground,
  Props,
  React
};